import React from "react"
import {
  EXTERNAL_URL,
  STATIC_SITE_MAP,
} from "../../hp-cms-module/_asial-websites-common/consts/asial-websites-sitemap.const"

import {
  AsialWebsitesCommonOuterLinkWhite,
  CloseMenuWhiteImg,
} from "../../images/images"
import styled from "styled-components"
import { SPOnlyFlex } from "../../styles/base-styles"

interface Props {
  toggleMenu: Function
}
interface MenuLinkProps {
  href: string
  title: string
  withIcon?: boolean
  toggleMenu: Function
  toBlank?: boolean
}

export const MenuSP: React.FC<Props> = ({ toggleMenu }) => {
  const MenuLink: React.FC<MenuLinkProps> = ({
    title,
    withIcon,
    href,
    toggleMenu,
    toBlank = false,
  }) => {
    return (
      <MenuLinkWrapper
        href={href}
        onClick={() => {
          setTimeout(() => toggleMenu(), 1400)
        }}
        target={toBlank ? "_blank" : "_self"}
        rel="noopener noreferre"
      >
        <MenuLinkTitle>{title}</MenuLinkTitle>
        {withIcon && (
          <MenuLinkIconDiv>
            <img
              src={AsialWebsitesCommonOuterLinkWhite}
              alt="outerlink-indicator"
            />
          </MenuLinkIconDiv>
        )}
      </MenuLinkWrapper>
    )
  }
  // （ヘッダー > Xボタン）｜ メニューコンテナー > （ブログトップ ｜ 運営会社 > メニューリスト）｜ Xボタン
  return (
    <Wrapper>
      <MenuHeader>
        <CloseMenuBlock onClick={() => toggleMenu()}>
          <img src={CloseMenuWhiteImg} alt="closeMenu1" />
        </CloseMenuBlock>
      </MenuHeader>
      <MenuBody>
        <MenuLinkListContainer>
          <MenuLinkListItem>
            <MenuLink
              href={"/"}
              title={"Blog トップ"}
              toggleMenu={toggleMenu}
            ></MenuLink>
          </MenuLinkListItem>
        </MenuLinkListContainer>
        <MenuLinkListContainer>
          <MenuLinkListItem>
            <MenuLink
              href={EXTERNAL_URL.ASIAL_HP}
              title={"運営会社（アシアル株式会社）"}
              toggleMenu={toggleMenu}
              toBlank
              withIcon={true}
            ></MenuLink>
          </MenuLinkListItem>
          <SubMenuLinkListItem>
            <MenuLink
              href={
                EXTERNAL_URL.ASIAL_HP + STATIC_SITE_MAP.COMPANY_INFORMATION.path
              }
              title={"会社概要"}
              toggleMenu={toggleMenu}
              toBlank
            ></MenuLink>
          </SubMenuLinkListItem>
          <SubMenuLinkListItem>
            <MenuLink
              href={EXTERNAL_URL.ASIAL_HP + STATIC_SITE_MAP.CAREERS.path}
              title={"採用情報"}
              toggleMenu={toggleMenu}
              toBlank
            ></MenuLink>
          </SubMenuLinkListItem>
          <SubMenuLinkListItem>
            <MenuLink
              href={EXTERNAL_URL.ASIAL_HP + STATIC_SITE_MAP.CONTACT.path}
              title={"お問い合わせ"}
              toggleMenu={toggleMenu}
              toBlank
            ></MenuLink>
          </SubMenuLinkListItem>
        </MenuLinkListContainer>
      </MenuBody>
      <CloseMenuBlock onClick={() => toggleMenu()}>
        <img src={CloseMenuWhiteImg} alt="closeMenu2" />
      </CloseMenuBlock>
    </Wrapper>
  )
}

const Wrapper = styled(SPOnlyFlex)`
  width: 100%;
  height: 100%;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
`
const MenuHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`
const MenuBody = styled.div`
  width: 85%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`
const CloseMenuBlock = styled.div`
  margin: 16px 24px;
`

const MenuLinkListContainer = styled.ul`
  list-style: none;
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: flex-end;
  margin: 0 24px 48px;
`

const MenuLinkListItem = styled.li`
  list-style: none;
  width: 100%;
  margin-bottom: 12px;
  border-bottom: 2px solid var(--ffb-98-a, #ffb98a);
  color: var(--White, #fff);
  font-feature-settings: "clig" off, "liga" off;
  /* SP_text_l */
  font-family: san-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 28.8px */
  letter-spacing: 1.28px;
  display: flex;
  flex-flow: column;
`
const SubMenuLinkListItem = styled.li`
  list-style: none;
  width: 93.5%;
  margin-bottom: 12px;
  border-bottom: 2px solid var(--ffb-98-a, #ffb98a);
  color: var(--White, #fff);
  font-feature-settings: "clig" off, "liga" off;
  /* SP_text_l */
  font-family: san-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 28.8px */
  letter-spacing: 1.28px;
  display: flex;
  flex-flow: column;
`
const MenuLinkWrapper = styled.a`
  width: 100%;
  height: 100%;
  display: flex;
  text-decoration: none;
  color: inherit; /* 色も変更したい場合 */
  border: none; /* ボーダーを削除 */
  padding: 8px 8px 18px 8px;
`
const MenuLinkTitle = styled.span`
  flex: 1 1 auto;
`
const MenuLinkIconDiv = styled.span`
  flex: 0 0 24px;
`
